export default "__VITE_ASSET__UXBql2Vq__"